import { Injectable } from '@angular/core';
import { IStoreBase } from '@boxx/core';
import {
  IStoreVariationsStateError,
  IStoreVariationsStateSuccess,
  VariationModel,
} from '@boxx/store-core';
import { Store } from '@ngrx/store';
import * as fromReducer from '../store.reducer';
import * as fromVariationsActions from './store-variations.actions';
import * as fromSelectors from './store-variations.selectors';

@Injectable()
export class StoreVariationsStore
  implements
    IStoreBase<
      VariationModel[],
      IStoreVariationsStateSuccess,
      IStoreVariationsStateError
    >
{
  constructor(public store: Store<fromReducer.IStoreState>) {}

  get loading$() {
    return this.store.select(fromSelectors.getStoreVariationsIsLoading);
  }
  get data$() {
    return this.store.select(fromSelectors.getStoreVariationsData);
  }
  get fetched$() {
    return this.store.select(fromSelectors.getStoreVariationsHasBeenFetched);
  }
  get error$() {
    return this.store.select(fromSelectors.getStoreVariationsError);
  }
  get success$() {
    return this.store.select(fromSelectors.getStoreVariationsSuccess);
  }

  fetch = () =>
    this.store.dispatch(fromVariationsActions.loadVariationsBeginAction());

  // createVariation = (payload: ICreateVariationPayload) =>
  //   this.store.dispatch(
  //     fromVariationsActions.creteVariationBeginAction({ payload })
  //   );

  // deleteVariation = (payload: number) =>
  //   this.store.dispatch(
  //     fromVariationsActions.delteVariationBeginAction({ payload })
  //   );
}
